module.exports = __webpack_public_path__ + "img/stamp-pending.9ce29c63.png";